module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-news",
    attrs: {
      "id": "mobile-news"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/explore/xfz2017/",
      "target": "_blank"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/explore/xfz2017/#s-guest",
      "target": "_blank"
    }
  }, [_vm._v("参会嘉宾")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/explore/xfz2017/#s-agenda",
      "target": "_blank"
    }
  }, [_vm._v("会议议程")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/explore/xfz2017/#s-tickets",
      "target": "_blank"
    }
  }, [_vm._v("参会购票")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/explore/xfz2017/#s-partners",
      "target": "_blank"
    }
  }, [_vm._v("合作机构")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/explore/xfz2017/#s-location",
      "target": "_blank"
    }
  }, [_vm._v("场地信息")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/explore/xfz2017/#s-contact-us",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "banner",
    attrs: {
      "id": "section-banner"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "mobile-news-wrap"
  }, [_c('div', {
    staticClass: "section live"
  }, [_c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_c('img', {
    staticClass: "img-title",
    attrs: {
      "src": require("../assets/images/m-news.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "refresh",
    on: {
      "click": function($event) {
        _vm.refreshContent()
      }
    }
  }, [_vm._v(" 刷新 ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-news-list"
  }, [(false) ? _c('div', {
    staticClass: "title-area"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("大会相关新闻")]), _vm._v(" "), _c('div', {
    staticClass: "refresh",
    on: {
      "click": function($event) {
        _vm.refreshContent()
      }
    }
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "refresh-content"
  }, [_vm._v("刷新")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.newsData), function(item) {
    return [_c('mobile-news-item', {
      attrs: {
        "news": item
      }
    })]
  }), _vm._v(" "), (_vm.newsData.length == 0) ? [_c('div', {
    staticStyle: {
      "width": "200px",
      "text-align": "center",
      "margin": "20px auto",
      "font-size": "18px"
    }
  }, [_vm._v("暂无新闻")]), _vm._v(" "), _c('br')] : _vm._e()], 2), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-news-wrap"
  }, [_c('div', {
    staticClass: "section live"
  }, [_c('div', {
    staticClass: "live-wrap"
  }, [_c('div', {
    staticClass: "live-title"
  }, [_c('img', {
    staticClass: "img-title",
    attrs: {
      "src": require("../assets/images/video-mo.png"),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section course"
  }, [_c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("未来创新专场")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, [_c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/178.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    staticClass: "main",
    attrs: {
      "src": "http://static-image.xfz.cn/1513063811_824.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("吉姆·罗杰斯/量子基金创办人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/179.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    staticClass: "main",
    attrs: {
      "src": "http://static-image.xfz.cn/1513065034_406.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("李黎/嘉程资本创始合伙人、小饭桌创始人； 张颖/经纬中国创始管理合伙人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/180.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    staticClass: "main",
    attrs: {
      "src": "http://static-image.xfz.cn/1513065071_142.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("张巳丁/ofo小黄车联合创始人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/181.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    staticClass: "main",
    attrs: {
      "src": "http://static-image.xfz.cn/1513066076_626.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("郭晨凯/韬映资本董事总经理；吉姆·罗杰斯/量子基金基金创办人 ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/182.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    staticClass: "main",
    attrs: {
      "src": "http://static-image.xfz.cn/1513066148_85.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("脱不花/得到App联合创始人兼CEO ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("未来智慧专场")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, [_c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/183.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513066172_946.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("于伟/微软全球合伙人、微软亚太研发集团工程院副院长")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/184.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513066370_185.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("Yosi Lahad/Co-Founder of NextWave Robotics")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/185.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513066402_508.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("谢冠超/云知声IOT事业部总裁")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/186.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513648493_271.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("汪玉/深鉴科技联合创始人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/187.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513067515_281.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("钱诚/寒武纪副总裁")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/188.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513068771_16.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("黄畅/地平线联合创始人兼算法副总裁")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/189.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513073996_456.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("主持：张一甲 ,科技智库甲子光年创始人兼CEO")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("未来消费专场")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, [_c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/191.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074060_532.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("陈安妮/快看漫画创始人兼CEO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/192.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074088_956.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("司江华/猩便利联合创始人兼总裁")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/193.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074115_897.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("张剑/纳什空间创始人兼CEO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/194.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074138_654.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("刘锐/天使之橙、Vingoo维果部落联合创始人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/195.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074316_971.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("主持人：曲凯，42章经创始人")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course-title"
  }, [_vm._v("未来科技金融专场")]), _vm._v(" "), _c('div', {
    staticClass: "course-items-wrap"
  }, [_c('div', {
    staticClass: "course-area"
  }, [_c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/197.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074335_754.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("吴逖/众安保险副总经理兼CMO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/198.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513648695_27.jpg-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("汤鹏/量子保创始人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/199.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074402_194.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("陈龙/大象保险CTO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/200.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074430_204.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("巫天华/老虎证券创始人兼CEO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/201.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074473_908.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("主持人：陈一佳 , 路透财经评论员")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/203.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513075126_301.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("Madhu, CEO of KrazyBee")])])])]), _vm._v(" "), _c('div', {
    staticClass: "course-item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.xfz.cn/course/202.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/1513074496_627.png-course.list.small",
      "alt": "资本寒冬，创业公司如何快速获取融资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tags"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-author"
  }, [_vm._v("主持人：谢荫智, CBIPA中巴互联网促进会CEO")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "refresh-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-refresh.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed65880"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileNews.vue
// module id = 155
// module chunks = 1